import { DependenciesPayload } from '@sxm-de/dev-kits/web-sdk/types';

export async function recordPrivacyOptionForIdentity({
    clientSdk,
    appEventSdk,
}: DependenciesPayload): Promise<void> {
    try {
        await clientSdk.user.recordPrivacyOptionByIdentityId();
    } catch (error: any) {
        /**
         * Note:
         * We are silently catching this
         */
    }
}
